module.exports = __webpack_public_path__ + "7b6a2771d9a8b9b36538cd6a4b2e286c.svg";